import { useMemo } from 'react';
import { academyBadges, Badge, UserBadge } from '../data/badge';

export interface UseBadgesResult {
  badgesWithEarnedStatus: Badge[];
  unlockedCount: number;
  totalBadgesCount: number;
}

/**
 * Hook for handling badge-related logic
 */
export function useBadges(userBadges: UserBadge[]): UseBadgesResult {
  // Calculate earned badges
  const badgesWithEarnedStatus = useMemo(() => {
    return academyBadges.map(badge => ({
      ...badge,
      isEarned: userBadges.some(
        userBadge => userBadge.badgeType === badge.badgeType
      ),
    }));
  }, [userBadges]);

  const earnedBadges = useMemo(() => {
    return badgesWithEarnedStatus.filter(badge => badge.isEarned);
  }, [badgesWithEarnedStatus]);

  // Calculate total unlocked count
  const unlockedCount = useMemo(() => {
    return earnedBadges.length;
  }, [earnedBadges]);

  return {
    badgesWithEarnedStatus,
    unlockedCount,
    totalBadgesCount: academyBadges.length,
  };
}
